module.exports = __webpack_public_path__ + "media/images/vcss-blue-9e49c3f7c4d063d18c1a074d6ac2675f.gif";